<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-返佣设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--返佣设置-->
      <div class="common-form">返佣金额设置</div>
      
      <el-form-item label="一级代理返佣金额" prop="level1_agent_rebate">
        <el-input v-model="form.level1_agent_rebate" placeholder="请输入一级代理返佣金额" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="代理推荐的优惠" prop="agent_client_rebate">
        <el-input v-model="form.agent_client_rebate" placeholder="请输入代理推荐的优惠" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="老客户返佣金额" prop="old_client_rebate">
        <el-input v-model="form.old_client_rebate" placeholder="请输入老客户返佣金额" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="老客户推荐的优惠" prop="old_client_ref_rebate">
        <el-input v-model="form.old_client_ref_rebate" placeholder="请输入老客户推荐的优惠" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

       <el-form-item label="通过分享链接注册的客户分享人返佣金额" prop="referee_agent_rebate">
        <el-input v-model="form.referee_agent_rebate" placeholder="通过分享链接注册的客户分享人返佣金额" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="通过分享链接注册的优惠金额" prop="referee_client_rebate">
        <el-input v-model="form.referee_client_rebate" placeholder="通过分享链接注册的客户优惠金额" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import _ from 'lodash'
import Upload from "@/components/file/Upload"
export default {
  components: {
    Upload,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      isAboutBannerUpload: false,
      isAboutCardUpload: false,
      isAboutLogoUpload: false,
      
      /*form表单数据*/
      form: {
        // 返佣设置
        level1_agent_rebate: '', // 一级代理返佣金额
        agent_client_rebate: '', // 代理推荐的客户返佣金额
        old_client_rebate: '',   // 老客户返佣金额
        old_client_ref_rebate: '', // 老客户推荐的客户返佣金额
        referee_agent_rebate:'',
        referee_client_rebate:'',
      },
      w7: {},
      all_type: [],
      type: [],
    }
  },
  created() {
    this.getParams()
  },
  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this
      SettingApi.rakeDetail({}, true).then(res => {
        if (res.code) {
          self.form.checkedCities = res.data.vars.values.delivery_type
          let vars = res.data.vars.values
          self.form = _.merge(self.form, res.data.vars.values)

          self.type = vars.delivery_type
          self.all_type = res.data.all_type
          self.w7 = res.data.w7
          self.loading = false
        } else {
          self.$message.error('获取配置数据失败')
        }
      }).catch(error => {
        console.log(error)
      })
    },

    /*提交*/
    onSubmit() {
      let self = this
      let params = this.form
      
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.editRake(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '设置保存成功',
                type: 'success',
              })
              self.$router.push('/setting/store/index')
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    
    
   
  }
}
</script>

<style scoped lang="scss">
.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.max-w460 {
  max-width: 460px;
}

.common-button-wrapper {
  margin-top: 30px;
  padding-left: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/rake/index.vue